// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__wXFYt","footer":"ReportModalFilter_footer__1m0CE"};